type NumberParts = { integer: number; fraction: number };

// avoid rounding error
const getFraction = (value: number): number => {
  const valueString = value.toString();

  return valueString.includes('.')
    ? parseFloat(value.toString().replace(/^\d*\./, '0.'))
    : 0;
};

export const splitNumberParts = (value: number, step: number): NumberParts => {
  if (step > 1) {
    throw new RangeError('step must be lower than or equal to 1');
  }
  const integer = Math.floor(value);
  // NOTE: 丸め誤差防止の為
  const fraction = Math.round(getFraction(value) / step) / (1 / step);
  return {
    integer,
    fraction,
  };
};

const numberFormatter = new Intl.NumberFormat('ja-JP');
export const formatToCommaSeparated = (value: number): string => {
  return numberFormatter.format(value);
};
